<template>
  <div class="detail-page">
    <NavBar />
    <main class="detail-main" :aria-busy="loading">
      <aside class="detail-sidebar">
        <div class="sidebar-title"><i class="bi bi-journal-bookmark" aria-hidden="true"></i>Eğitim kategorileri</div>
        <nav class="category-nav" aria-label="Eğitim kategorileri">
          <router-link :to="{ name: 'Market', query: { campaingcode: CampaingCode } }">Tüm eğitimler</router-link>
          <router-link v-if="category?.parentId" :to="detailRoute(category.parentId)" class="parent-category"><i class="bi bi-arrow-left" aria-hidden="true"></i> Üst kategoriye dön</router-link>
          <router-link v-for="item in navigationCategories" :key="item.id" :to="detailRoute(item.id)"
            :class="{ selected: String(item.id) === String($route.params.id) }"
            :aria-current="String(item.id) === String($route.params.id) ? 'page' : undefined">{{ item.categoryName }}</router-link>
        </nav>
      </aside>
      <div class="detail-content">
      <router-link :to="backRoute" class="back-link"><i class="bi bi-arrow-left" aria-hidden="true"></i>{{ category?.parentId ? 'Üst eğitime dön' : 'Tüm eğitimler' }}</router-link>

      <div v-if="loading" class="detail-state" role="status">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <p>Eğitim bilgileri yükleniyor…</p>
      </div>
      <div v-else-if="loadError" class="detail-state" role="alert">
        <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
        <h1>Eğitim bilgilerine ulaşamadık.</h1>
        <p>Lütfen biraz sonra tekrar dene.</p>
        <button type="button" class="retry-button" @click="Init">Tekrar dene</button>
      </div>
      <template v-else-if="category">
        <header class="detail-hero" :class="{ 'has-image': categoryImage }">
          <div class="hero-copy">
            <span class="eyebrow">EĞİTİM PROGRAMI</span>
            <h1>{{ category.categoryName }}</h1>
            <p v-if="categoryProperties.summaryDescription">{{ categoryProperties.summaryDescription }}</p>
            <div class="feature-list">
              <span v-if="categoryProperties.lessonCount !== ''"><i class="bi bi-book" aria-hidden="true"></i>{{ categoryProperties.lessonCount }} ders</span>
              <span v-if="categoryProperties.isQuiz"><i class="bi bi-stopwatch" aria-hidden="true"></i>Quiz</span>
              <span v-if="categoryProperties.isListen"><i class="bi bi-headphones" aria-hidden="true"></i>Dinleme</span>
              <span v-if="categoryProperties.isVideo"><i class="bi bi-play-circle" aria-hidden="true"></i>Video</span>
            </div>
          </div>
          <div v-if="categoryImage" class="hero-image"><img :src="categoryImage" alt=""></div>
        </header>

        <section v-if="categoryProperties.description" class="detail-panel program-panel">
          <h2 class="disclosure-heading">
            <button type="button" :aria-expanded="descriptionIsOpen" aria-controls="program-description" @click="descriptionIsOpen = !descriptionIsOpen">
              <span><span class="eyebrow">NELER ÖĞRENECEKSİN?</span><span class="section-title">Program kazanımları</span></span>
              <i :class="descriptionIsOpen ? 'bi bi-dash-lg' : 'bi bi-plus-lg'" aria-hidden="true"></i>
            </button>
          </h2>
          <div v-show="descriptionIsOpen" id="program-description" class="program-description" v-html="categoryProperties.description"></div>
        </section>

        <section v-if="subCategories.length" class="content-section" aria-labelledby="programs-title">
          <div class="section-heading"><div><span class="eyebrow">SONRAKİ ADIM</span><h2 id="programs-title">Eğitimini seç</h2></div><span class="section-count">{{ subCategories.length }} seçenek</span></div>
          <div class="program-grid">
            <router-link v-for="item in subCategories" :key="item.id" :to="detailRoute(item.id)" class="program-card">
              <div class="program-art">
                <img v-if="item.image" :src="item.image" class="program-image" alt="" width="960" height="480" loading="lazy" decoding="async">
                <i v-else class="bi bi-book" aria-hidden="true"></i>
              </div>
              <div class="program-copy">
                <div v-if="item.details.level.length" class="program-levels" aria-label="Eğitim seviyeleri"><span v-for="level in item.details.level" :key="level">{{ level }}</span></div>
                <h3>{{ item.categoryName }}</h3>
                <p v-if="item.details.summaryDescription">{{ item.details.summaryDescription }}</p>
                <div class="program-action"><span class="details-button">Detaylar <i class="bi bi-arrow-right" aria-hidden="true"></i></span><span v-if="item.details.lessonCount !== ''" class="program-lessons">{{ item.details.lessonCount }} ders</span></div>
              </div>
            </router-link>
          </div>
        </section>

        <section v-if="category.bookSubjects?.length" class="detail-panel curriculum" aria-labelledby="curriculum-title">
          <div class="section-heading"><div><span class="eyebrow">PROGRAM İÇERİĞİ</span><h2 id="curriculum-title">Derslere göz at</h2></div><span class="section-count">{{ BookSubjectList.length }} konu</span></div>
          <div v-if="categoryProperties.level.length" class="level-options" role="group" aria-label="Eğitim seviyesi">
            <button v-for="(level, index) in categoryProperties.level" :key="level" type="button" :aria-pressed="selectLevel === index + 1" :class="{ selected: selectLevel === index + 1 }" @click="selectLevel = index + 1">{{ level }}</button>
          </div>
          <ol v-if="BookSubjectList.length" class="subject-list" aria-label="Ders konuları" tabindex="0">
            <li v-for="(subject, index) in BookSubjectList" :key="`${subject.bookSubjectId}-${index}`">
              <span class="subject-number" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>
              <span class="subject-name">{{ subject.bookSubject }}</span>
              <router-link v-if="subject.bookSubjectId != null" :to="{ path: '/market/simplebook/', query: { id: subject.bookSubjectId } }" :aria-label="`${subject.bookSubject} dersine göz at`">Derse göz at <i class="bi bi-arrow-up-right" aria-hidden="true"></i></router-link>
            </li>
          </ol>
          <p v-else class="empty-subjects">Bu seviye için henüz ders içeriği bulunmuyor.</p>
        </section>
        <div v-else-if="categoryProperties.level.length" class="available-levels" aria-label="Eğitim seviyeleri"><span>Seviyeler</span><span v-for="level in categoryProperties.level" :key="level" class="level-label">{{ level }}</span></div>

        <div v-if="!categories.length" class="package-section">
          <MarketSelectPackage :key="`${category.id}-${CampaingCode}`"
            :CategoryId="category.id"
            :PackageId="categoryProperties.packageId"
            :PackageMonth="categoryProperties.packageMonth"
            :PackageDuration="categoryProperties.packageDuration"
            :PackageWeeklyDay="categoryProperties.packageWeeklyDay"
            :CampaingCode="CampaingCode" />
        </div>
        <footer class="detail-help"><router-link to="/faq"><i class="bi bi-question-circle" aria-hidden="true"></i> Soruların mı var? <span>Sıkça sorulan sorular <i class="bi bi-arrow-up-right" aria-hidden="true"></i></span></router-link></footer>
      </template>
      </div>
    </main>
    <FooterInPage />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import MarketSelectPackage from '@/components/Market/MarketSelectPackage.vue';
import { GetCategoryProperty } from '@/common/market-helper';
import { getMarketImage } from '@/common/market-image';

export default {
  name: 'MarketDetailPage',
  components: { NavBar, FooterInPage, MarketSelectPackage },
  data() {
    return { category: null, categories: [], navigationCategories: [], loading: true, loadError: false, descriptionIsOpen: false, selectLevel: 1, requestId: 0 };
  },
  computed: {
    categoryProperties() { return GetCategoryProperty(this.category?.properties); },
    categoryImage() {
      return getMarketImage(this.categoryProperties);
    },
    subCategories() {
      return this.categories.map(item => {
        const details = GetCategoryProperty(item.properties);
        return { ...item, details, image: getMarketImage(details) };
      });
    },
    BookSubjectList() {
      const subjects = this.category?.bookSubjects || [];
      return this.categoryProperties.level.length ? subjects.filter(item => item.level == this.selectLevel) : subjects;
    },
    CampaingCode() { return this.$route.query.campaingcode || ''; },
    backRoute() {
      return this.category?.parentId ? this.detailRoute(this.category.parentId) : { name: 'Market', query: { campaingcode: this.CampaingCode } };
    }
  },
  methods: {
    ...mapActions(['GetCategories', 'GetCategory', 'AddMarketEvent']),
    detailRoute(id) { return { name: 'MarketDetail', params: { id }, query: { campaingcode: this.CampaingCode } }; },
    async Init() {
      const request = ++this.requestId;
      const categoryId = this.$route.params.id;
      this.loading = true;
      this.loadError = false;
      this.category = null;
      this.categories = [];
      this.selectLevel = 1;
      this.descriptionIsOpen = false;
      try {
        const [category, categories] = await Promise.all([this.GetCategory(categoryId), this.GetCategories(categoryId)]);
        if (request !== this.requestId) return;
        if (!category || !Array.isArray(categories)) throw new Error('Invalid category response');
        const navigationCategories = await this.GetCategories(category.parentId || null);
        if (request !== this.requestId) return;
        if (!Array.isArray(navigationCategories)) throw new Error('Invalid navigation response');
        this.category = category;
        this.categories = categories;
        this.navigationCategories = navigationCategories;
        let description = '"' + category.categoryName + '" giriş yapıldı.';
        if (this.CampaingCode) description += ' (Kampanya Kodu : ' + this.CampaingCode + ')';
        // Analytics failures should not hide a successfully loaded program.
        this.AddMarketEvent({ event: categories.length ? 2 : 3, categoryId, description }).catch(() => {});
      } catch {
        if (request === this.requestId) this.loadError = true;
      } finally {
        if (request === this.requestId) this.loading = false;
      }
    }
  },
  watch: { '$route.params.id'() { this.Init(); } },
  mounted() { this.Init(); },
  beforeUnmount() { ++this.requestId; }
};
</script>

<style scoped>
.detail-page { min-height: 100vh; background: #fff; color: #10243a; }
.detail-main { display: grid; grid-template-columns: 240px minmax(0, 1fr); max-width: 1680px; margin: auto; padding: 0 32px; }
.detail-sidebar { border-right: 1px solid #e5e9e8; padding: 48px 24px 32px 0; }
.sidebar-title { display: flex; align-items: center; gap: 10px; margin-bottom: 18px; color: #637489; font-size: 13px; font-weight: 600; }
.sidebar-title i { color: var(--brand-link); font-size: 18px; }
.category-nav { display: flex; flex-direction: column; gap: 6px; position: sticky; top: 24px; }
.category-nav a { border-radius: 8px; padding: 12px 14px; color: #34483b; text-decoration: none; font-size: 14px; font-weight: 600; line-height: 1.5; overflow-wrap: anywhere; }
.category-nav a:hover { background: #f5f8f6; }
.category-nav a.selected { background: #eaf4ee; color: var(--brand-link); }
.category-nav .parent-category { font-size: 12px; color: #637489; }
.detail-content { min-width: 0; padding: 48px 0 32px 44px; }
.back-link { display: inline-flex; align-items: center; gap: 9px; margin-bottom: 24px; padding: 6px 0; color: #637489; text-decoration: none; font-size: 13px; }
.back-link:hover { color: var(--brand-link); }
.detail-hero { display: grid; gap: 28px; align-items: center; margin-bottom: 32px; }
.detail-hero.has-image { grid-template-columns: 1.2fr 1fr; }
.eyebrow { display: block; color: var(--brand-link); font-size: 10px; font-weight: 700; letter-spacing: 1.4px; line-height: 1.6; }
.hero-copy h1 { font-size: clamp(28px, 4vw, 40px); font-weight: 750; line-height: 1.2; letter-spacing: -1.2px; margin: 12px 0; overflow-wrap: anywhere; }
.hero-copy > p { font-size: 14px; line-height: 1.8; color: #637489; margin-bottom: 20px; }
.hero-image { overflow: hidden; border-radius: 18px; background: #edf3f4; }
.hero-image img { display: block; width: 100%; height: auto; max-height: 260px; object-fit: contain; }
.feature-list { display: flex; flex-wrap: wrap; gap: 8px; }
.feature-list > span { display: inline-flex; align-items: center; gap: 7px; background: #edf3f2; color: #426558; border-radius: 7px; padding: 7px 10px; font-size: 12px; }
.detail-panel { background: #fff; border: 1px solid #e0e6ed; border-radius: 18px; margin-bottom: 24px; }
.disclosure-heading { margin: 0; }
.disclosure-heading button { display: flex; align-items: center; justify-content: space-between; gap: 20px; width: 100%; padding: 24px; border: 0; border-radius: 18px; background: transparent; color: #10243a; text-align: left; }
.disclosure-heading button > i { font-size: 18px; color: var(--brand-link); }
.section-title { display: block; font-size: 20px; font-weight: 700; margin-top: 5px; letter-spacing: -.4px; }
.program-description { margin: 0 24px; padding: 20px 0 24px; border-top: 1px solid #edf0f4; font-size: 14px; color: #52667b; line-height: 1.85; overflow-wrap: anywhere; overflow-x: auto; }
.program-description :deep(img) { max-width: 100%; height: auto; }
.program-description :deep(p:last-child) { margin-bottom: 0; }
.content-section { margin: 32px 0; }
.section-heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 20px; }
.section-heading h2 { font-size: 22px; font-weight: 700; letter-spacing: -.5px; margin: 5px 0 0; }
.section-count { color: #637489; font-size: 12px; flex-shrink: 0; }
.program-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; }
.program-card { display: flex; flex-direction: column; min-width: 0; overflow: hidden; border: 1px solid #e0e6ed; border-radius: 10px; background: #fff; color: #10243a; text-decoration: none; transition: border-color .2s, box-shadow .2s; }
.program-art { display: grid; place-items: center; aspect-ratio: 2 / 1; overflow: hidden; background: #edf3f4; }
.program-art > i { font-size: 44px; color: #69998a; }
.program-image { display: block; width: 100%; height: 100%; object-fit: contain; }
.program-card:hover { border-color: #a9c8bc; box-shadow: 0 8px 24px #10243a08; }
.program-copy { display: flex; flex-direction: column; flex: 1; min-width: 0; padding: 22px; overflow-wrap: anywhere; }
.program-copy h3 { font-size: 21px; font-weight: 600; letter-spacing: -.5px; line-height: 1.4; margin: 0 0 10px; }
.program-copy p { font-size: 14px; color: #637489; line-height: 1.75; margin: 0 0 20px; }
.program-levels { display: flex; flex-wrap: wrap; gap: 5px; margin-bottom: 12px; }
.program-levels span { border-radius: 4px; background: #edf2ed; padding: 4px 7px; font-size: 10px; font-weight: 600; color: #4c6256; }
.program-action { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-top: auto; padding-top: 24px; font-size: 12px; color: var(--brand-link); }
.details-button { display: inline-flex; align-items: center; gap: 10px; border: 1px solid #b6c6bd; border-radius: 24px; padding: 7px 14px; }
.program-card:hover .details-button { background: #edf7f2; border-color: var(--brand-link); }
.program-lessons { font-size: 12px; color: #637489; margin-left: auto; }
.curriculum { padding: 24px; }
.level-options, .available-levels { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }
.level-options button, .level-label { border: 1px solid #e0e6ed; border-radius: 8px; padding: 8px 15px; background: #fff; color: #52667b; font-size: 13px; }
.level-options button:hover { border-color: var(--brand-link); }
.level-options button.selected { background: var(--brand-link); color: #fff; border-color: var(--brand-link); }
.available-levels { align-items: center; color: #637489; font-size: 13px; }
.subject-list { list-style: none; margin: 0; padding: 0; max-height: 380px; overflow-y: auto; scrollbar-width: thin; }
.subject-list li { display: flex; align-items: center; gap: 14px; padding: 16px 0; border-top: 1px solid #edf0f4; font-size: 14px; }
.subject-number { color: #7c8998; font-size: 12px; font-variant-numeric: tabular-nums; }
.subject-name { flex: 1; min-width: 0; overflow-wrap: anywhere; text-transform: capitalize; }
.subject-list a { display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0; padding: 5px 0; color: var(--brand-link); font-size: 12px; font-weight: 600; text-decoration: none; }
.subject-list a:hover { text-decoration: underline; }
.empty-subjects { margin: 0; padding: 20px 0; font-size: 14px; color: #637489; }
.package-section :deep(.accordion-item) { border: 1px solid #e0e6ed; border-radius: 18px; overflow: hidden; }
.package-section :deep(.accordion-button) { background: #fff !important; color: #10243a; padding: 24px; font-size: 18px; box-shadow: none; }
.package-section :deep(.accordion-button:not(.collapsed)) { border-bottom: 1px solid #edf0f4; }
.package-section :deep(.accordion-body) { padding: 24px; }
.package-section :deep(.btn-group) { display: inline-flex; flex-wrap: wrap; gap: 8px; }
.package-section :deep(.btn-group > .btn) { border-radius: 9px !important; margin: 0; font-size: 14px; padding: 10px 12px; }
.package-section :deep(.btn-outline-secondary) { --bs-btn-color: #52667b; --bs-btn-border-color: #dce4e9; --bs-btn-hover-color: var(--brand-link); --bs-btn-hover-bg: #edf7f2; --bs-btn-hover-border-color: var(--brand-link); --bs-btn-active-color: #fff; --bs-btn-active-bg: var(--brand-link); --bs-btn-active-border-color: var(--brand-link); }
.package-section :deep(.card) { border-color: #dce7e1; border-radius: 14px; background: #f8fcfa; }
.package-section :deep(.card-body) { padding: 24px; }
.package-section :deep(.btn-primary) { --bs-btn-bg: var(--brand-link); --bs-btn-border-color: var(--brand-link); --bs-btn-hover-bg: #06634d; --bs-btn-hover-border-color: #06634d; border-radius: 10px; font-size: 15px; padding: 12px; }
.detail-state { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 14px; padding: 64px 24px; border: 1px solid #e0e6ed; border-radius: 18px; background: #fff; color: #637489; }
.detail-state > i { font-size: 30px; color: var(--brand-link); }
.detail-state h1 { font-size: 22px; color: #10243a; margin: 0; }
.detail-state p { margin: 0; font-size: 14px; }
.retry-button { border: 0; border-radius: 10px; padding: 12px 20px; background: var(--brand-link); color: #fff; }
.detail-help { margin-top: 32px; text-align: center; }
.detail-help a { display: inline-flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 8px; padding: 8px 0; font-size: 13px; color: #637489; text-decoration: none; }
.detail-help span { color: var(--brand-link); }
.detail-help a:hover span { text-decoration: underline; }
.detail-main a:focus-visible, .detail-main button:focus-visible, .subject-list:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
@media (max-width: 1399px) {
  .detail-main { grid-template-columns: 210px minmax(0, 1fr); padding: 0 24px; }
  .detail-content { padding-left: 28px; }
  .program-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 1099px) { .program-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 767px) {
  .detail-main { display: block; padding: 0 18px; }
  .detail-sidebar { padding: 24px 0 18px; border-right: 0; border-bottom: 1px solid #e5e9e8; }
  .sidebar-title { margin-bottom: 12px; }
  .category-nav { position: static; flex-direction: row; overflow-x: auto; padding: 4px; scrollbar-width: thin; }
  .category-nav a { flex-shrink: 0; max-width: 260px; padding: 10px 14px; }
  .detail-content { padding: 28px 0 24px; }
  .detail-hero.has-image { grid-template-columns: 1fr; }
  .detail-hero { gap: 22px; }
  .hero-image img { max-height: 220px; }
  .curriculum, .program-copy, .disclosure-heading button { padding: 20px; }
  .program-description { margin: 0 20px; }
  .subject-list li { flex-wrap: wrap; gap: 10px; }
  .subject-name { flex-basis: calc(100% - 36px); }
  .subject-list a { margin-left: 26px; }
  .package-section :deep(.accordion-button), .package-section :deep(.accordion-body), .package-section :deep(.card-body) { padding: 20px; }
}
@media (max-width: 575px) { .program-grid { grid-template-columns: 1fr; gap: 18px; } }
@media (prefers-reduced-motion: reduce) { .program-card { transition: none; } }
</style>
